import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import $ from "jquery";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import { showLoader, hideLoader, showAlert, isEmpty, showContaimerLoader, isPhone, isEmail, removeChar, hasPermission } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
const module = "hospital";
const modulePath = "/hospital";
const moduleName = "Hospital";
const moduleID = 10;
class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        hospitalName: "",
        doctorName: "",
        doctorAddress: "",
        doctorPhone: "",
        doctorEmail: "",
        doctorCity: "",
        doctorState: "",
      },
      detaildata: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;

          const clientupdatedata = {
            hospitalName: result.hospitalName,
            doctorName: result.doctorName,
            doctorAddress: result.doctorAddress,
            doctorPhone: result.doctorPhone,
            doctorEmail: result.doctorEmail,
            doctorCity: result.doctorCity,
            doctorState: result.doctorState,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    const postData = this.state.postdata;

    const postObject = {
      hospitalName: postData.hospitalName.toUpperCase(),
      doctorName: postData.doctorName.toUpperCase(),
      doctorAddress: postData.doctorAddress.toUpperCase(),
      doctorPhone: postData.doctorPhone,
      doctorEmail: postData.doctorEmail,
      doctorCity: postData.doctorCity.toUpperCase(),
      doctorState: postData.doctorState.toUpperCase(),
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                    },
                                    500,
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { hospitalName, doctorName, doctorAddress, doctorPhone, doctorEmail, doctorCity, doctorState } = props.fields;

  return {
    fields: ["hospitalName", "doctorName", "doctorAddress", "doctorPhone", "doctorEmail", "doctorCity", "doctorState"],
    validations: {
      hospitalName: [[isEmpty, hospitalName]],
      doctorName: [[isEmpty, doctorName]],
      doctorAddress: [[isEmpty, doctorAddress]],
      doctorPhone: [[isPhone, doctorPhone]],
      doctorEmail: [[isEmail, doctorEmail]],
      doctorCity: [[isEmpty, doctorCity]],
      doctorState: [[isEmpty, doctorState]],
    },
  };
}

class PostForm extends Component {
  goBack() {
    this.props.history.push(modulePath);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsghospitalName,
      errMsgdoctorName,
      errMsgdoctorAddress,
      errMsgdoctorPhone,
      errMsgdoctorEmail,
      errMsgdoctorCity,
      errMsgdoctorState = "";
    if ($validation.hospitalName.error.reason !== undefined) {
      errMsghospitalName = $validation.hospitalName.show && <span className="error">{$validation.hospitalName.error.reason}</span>;
    }
    if ($validation.doctorName.error.reason !== undefined) {
      errMsgdoctorName = $validation.doctorName.show && <span className="error">{$validation.doctorName.error.reason}</span>;
    }
    if ($validation.doctorAddress.error.reason !== undefined) {
      errMsgdoctorAddress = $validation.doctorAddress.show && <span className="error">{$validation.doctorAddress.error.reason}</span>;
    }
    if ($validation.doctorCity.error.reason !== undefined) {
      errMsgdoctorCity = $validation.doctorCity.show && <span className="error">{$validation.doctorCity.error.reason}</span>;
    }

    if ($validation.doctorState.error.reason !== undefined) {
      errMsgdoctorState = $validation.doctorState.show && <span className="error">{$validation.doctorState.error.reason}</span>;
    }
    if ($validation.doctorPhone.error.reason !== undefined) {
      errMsgdoctorPhone = $validation.doctorPhone.show && <span className="error">{$validation.doctorPhone.error.reason}</span>;
    }
    if ($validation.doctorEmail.error.reason !== undefined) {
      errMsgdoctorEmail = $validation.doctorEmail.show && <span className="error">{$validation.doctorEmail.error.reason}</span>;
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Hospital Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Hospital Name"
                name="hospitalName"
                value={fields.hospitalName}
                {...$field("hospitalName", (e) => onChange("hospitalName", e.target.value))}
              />
              {errMsghospitalName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Doctor Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Doctor Name"
                name="doctorName"
                value={fields.doctorName}
                {...$field("doctorName", (e) => onChange("doctorName", e.target.value))}
              />
              {errMsgdoctorName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Address<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Address"
                name="doctorAddress"
                value={fields.doctorAddress}
                {...$field("doctorAddress", (e) => onChange("doctorAddress", e.target.value))}
              />
              {errMsgdoctorAddress}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                City<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="City"
                name="doctorCity"
                value={fields.doctorCity}
                {...$field("doctorCity", (e) => onChange("doctorCity", e.target.value))}
              />
              {errMsgdoctorCity}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                State<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="State"
                name="doctorState"
                value={fields.doctorState}
                {...$field("doctorState", (e) => onChange("doctorState", e.target.value))}
              />
              {errMsgdoctorState}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Phone Number</label>
              <input
                type="text"
                className="form-control"
                placeholder="Phone Number"
                name="doctorPhone"
                value={fields.doctorPhone}
                {...$field("doctorPhone", (e) => onChange("doctorPhone", e.target.value))}
              />
              {errMsgdoctorPhone}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Email</label>
              <input
                type="text"
                className="form-control"
                placeholder="Email"
                name="doctorEmail"
                value={fields.doctorEmail}
                {...$field("doctorEmail", (e) => onChange("doctorEmail", e.target.value))}
              />
              {errMsgdoctorEmail}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Add New"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
